import TotalRevenueModule from "./TotalRevenueModule";
import ReferralsSaga from "../../redux/sagas/referrals";
import TotalRevenueReducer from "../../redux/reducers/totalRevenue";

export default {
  Component: TotalRevenueModule,
  moduleName: "totalRevenue",
  saga: ReferralsSaga("totalRevenue"),
  reducer: TotalRevenueReducer
};
